module.exports = __webpack_public_path__ + "static/media/LMS-&-learning.3828db84.png";